<div class="titulo" role="heading" aria-level="2">
    {{ titulo || grafico.titulo | easyplaceholder: "Título del gráfico" }}
</div>
<p>{{ grafico.descripcion }}</p>
<!-- Resto de los textos son parametros del objeto grafico (para efectos de localizacion) -->
<div class="graph-container print-resize">
    <div *ngIf="enableGraph && parentsLoaded" [ng2-highcharts]="grafico.chartData" class="print-resize"></div>
</div>
